module.exports = __webpack_public_path__ + "img/title-2.817fb53a.png";